class Accordion {
  constructor(element) {
    this.accordion = element;
    this.items = this.accordion.querySelectorAll(".accordion-block__item");
    this.init();
  }

  init() {
    this.items.forEach((item) => {
      const button = item.querySelector(".accordion-block__item-heading");
      const content = item.querySelector(".accordion-block__item-content");

      if (button && content) {
        // Hide content initially
        content.style.maxHeight = "0px";
        content.style.overflow = "hidden";
        content.style.transition =
          "max-height 0.3s ease , margin-top 0.3s ease";
        content.style.marginTop = "0px";

        button.addEventListener("click", () => {
          this.toggleItem(button, content);
        });
      }
    });
  }

  toggleItem(button, content) {
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    const icon = button.querySelector(".accordion-block__item-icon");

    if (isExpanded) {
      // Close
      button.setAttribute("aria-expanded", "false");
      content.style.maxHeight = "0px";
      content.style.marginTop = "0px";
      if (icon)
        icon.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><mask id="mask0_5662_3086" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><rect width="32" height="32" fill="#D9D9D9"/></mask><g mask="url(#mask0_5662_3086)"><path d="M15.0003 27.3337V17.0003H4.66699V15.0003H15.0003V4.66699H17.0003V15.0003H27.3337V17.0003H17.0003V27.3337H15.0003Z" fill="#071B2B"/></g></svg>';
    } else {
      // Open - read scrollHeight before writing
      const height = content.scrollHeight;
      button.setAttribute("aria-expanded", "true");
      requestAnimationFrame(function () {
        content.style.maxHeight = height + "px";
        content.style.marginTop = "30px";
      });
      if (icon)
        icon.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><mask id="mask0_5662_3079" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><rect width="32" height="32" fill="#D9D9D9"/></mask><g mask="url(#mask0_5662_3079)"><path d="M7.33301 17V15H24.6663V17H7.33301Z" fill="#071B2B"/></g></svg>';
    }
  }
}

// Initialize all accordions on the page
document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".accordion-block");
  accordions.forEach((accordion) => {
    new Accordion(accordion);
  });
});
